import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CodaltComponent } from 'src/app/codalt.component';
import { environment } from 'src/environments/environment';
import { compiledVersion } from '../../../compiled-version';
import { AuthorisationService } from '../../services/auth/authorisation.service';
import { PAGE_HEADER_E2E_SELECTORS } from './header.e2e-selector';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false,
})
export class HeaderComponent extends CodaltComponent implements OnInit {
    protected readonly e2eSelectors = PAGE_HEADER_E2E_SELECTORS;
    @Input()
    public mainTitle: string = environment.appTitle;
    @Input()
    public subTitle: string;
    @Input() backLink = '/';
    @Input() backQueryParams: { [key: string]: any };

    @Input() print: boolean;

    @Output()
    public clicked = new EventEmitter();

    protected mobile = false;

    constructor(private breakpointObserver: BreakpointObserver) {
        super();

        this.subscriptions.add(
            this.breakpointObserver.observe('(max-width: 722px)').subscribe(match => {
                this.mobile = match.matches;
            })
        );
    }

    ngOnInit() {
        if (AuthorisationService.hasRole(this.environment.roles.FormerEmployee)) {
            this.backLink = '/periodeverrekening';
        }
    }

    logoclick() {
        this.clicked.emit();
    }

    protected readonly compiledVersion = compiledVersion;
}
